export default __webpack_public_path__ + "static/media/Snd4.1ad4cd25.mp3";